
const Recaptcha = {
    install(Vue) {
        Vue.prototype.$recaptcha = {
            siteKey: null,
            init(siteKey) {
                if (!siteKey || this.siteKey) return;
                this.siteKey = siteKey;

                const script = document.createElement('script');
                script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
                script.async = true;
                document.head.appendChild(script);
            },
            async getToken(action) {
                if (!this.siteKey) {
                    console.warn("Recaptcha Site Key not set. Skipping token generation.");
                    return null;
                }

                return new Promise((resolve, reject) => {
                    if (window.grecaptcha) {
                        window.grecaptcha.ready(() => {
                            window.grecaptcha.execute(this.siteKey, { action: action })
                                .then(token => resolve(token))
                                .catch(err => {
                                    console.error("Recaptcha error:", err);
                                    resolve(null); // Resolve null to allow graceful degrade or fail
                                });
                        });
                    } else {
                        resolve(null);
                    }
                });
            }
        };
    }
};

export default Recaptcha;
